import img1 from "../../assets/images/Odoo/Process/Process1.jpg";
import img2 from "../../assets/images/Odoo/Process/Process2.jpg";
import img3 from "../../assets/images/Odoo/Process/Process3.jpg";
import img4 from "../../assets/images/Odoo/Process/process4.jpg";
import shap1 from "../../assets/images/Odoo/Process/shape-bg-1.webp";
import shap2 from "../../assets/images/Odoo/Process/shape-bg-2.webp";
import './process.css';

export default function Process() {
    return (
        
            <>
                {/* Working Process Area Start */}
                <section className="ts-working-area pt-100 pb-100">
                    <div className="container">
                 <div className="sec-title-three centered">
                        {/* <div className="sec-title_title">Process Flow</div> */}
                        <h2 className="sec-title_heading">Our Methodology</h2>
                        <div className="sec-title-three_text">
                            Get started with Odoo ERP seamlessly. We provide end-to-end solutions <br />to ensure a smooth transition and optimal performance.
                        </div>
                    </div>
                        <div className="row gx-0 gx-my-5 mb-md-5">
                            <div className="col-xl-3 col-lg-6 col-md-12">
                                <div className="tsworking">
                                    <img
                                        className="shape-bg-1"
                                        src={shap1}
                                        alt="Soten"
                                    />
                                    <div className="tsworking__thumb text-center">
                                        <img src={img1} alt="Soten" />
                                        <span>01</span>
                                    </div>
                                    <div className="tsworking__content text-center">
                                        <h3>Discovery &amp; Planning</h3>
                                        <p>
                                            We analyze your business needs, identify key requirements, and
                                            craft a strategic roadmap to ensure Odoo aligns perfectly with
                                            your goals
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-md-12">
                                <div className="tsworking tsworking-even">
                                    <img
                                        className="shape-bg-2"
                                        src={shap2}
                                        alt="Soten"
                                    />
                                    <div className="tsworking__thumb text-center">
                                        <img src={img2} alt="Soten" />
                                        <span>02</span>
                                    </div>
                                    <div className="tsworking__content text-center">
                                        <h3>Design &amp; Development</h3>
                                        <p>
                                            Our experts customize and configure Odoo to fit your unique
                                            processes, ensuring an intuitive and efficient ERP system
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-md-12">
                                <div className="tsworking">
                                    <img
                                        className="shape-bg-1"
                                        src={shap1}
                                        alt="Soten"
                                    />
                                    <div className="tsworking__thumb text-center">
                                        <img src={img3} alt="Soten" />
                                        <span>03</span>
                                    </div>
                                    <div className="tsworking__content text-center">
                                        <h3>Testing &amp; Optimization</h3>
                                        <p>
                                            We rigorously test the system for performance, security, and
                                            usability, making sure it meets your business standards before
                                            deployment
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-md-12">
                                <div className="tsworking tsworking-even mb-md-0">
                                    <div className="tsworking__thumb text-center">
                                        <img src={img4} alt="Soten" />
                                        <span>04</span>
                                    </div>
                                    <div className="tsworking__content text-center">
                                        <h3>Deployment &amp; Support</h3>
                                        <p>
                                            We implement the system smoothly with minimal downtime and
                                            provide continuous support, training, and upgrades to maximize
                                            efficiency
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* Working Process Area End */}
            </>
    );
}